<template>
  <div class="card">
    <div
      class="card-header"
      style="display: flex; justify-content: space-between"
    >
      <!-- add  activityDRAWER -->
      <a-drawer
        :title="$t('inscription.nouvInscri')"
        :width="720"
        :visible="inscriptinActDrawer"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <activity-multi-ins-form
          ref="activityMultiInsForm"
          @updateActivityInscription="updateActivities"
        ></activity-multi-ins-form>
      </a-drawer>
      <!-- multiple registration DRAWER -->
      <a-drawer
        :title="$t('inscriptionActivites.multipleRegistrationTitle')"
        :width="820"
        :visible="multipleRegistrationDrawer"
        :body-style="{ paddingBottom: '80px' }"
        @close="onMultipleRegistrationClose"
      >
        <activity-multiple-registration-form
          ref="multipleRegistrationForm"
          @updateActivityInscription="updateActivitiesMultipleRegistration"
        ></activity-multiple-registration-form>
      </a-drawer>
      <div class="d-flex" style="gap: 8px">
        <a-button type="primary" icon="plus" @click="startInsDrawer">
          {{ $t("inscription.nouvInscri") }}
        </a-button>
        <a-button icon="usergroup-add" @click="startMultipleRegistrationDrawer">
          {{ $t("inscriptionActivites.multipleRegistration") }}
        </a-button>
      </div>
      <!-- Download Modal Student List By Activity-->
      <download-by-activity
        :visible="downloadModalVisible"
        @close="downloadModalVisible = false"
      ></download-by-activity>
      <a-button icon="file-pdf" @click="downloadModalVisible = true">
        {{ $t("action.imprimer") }}
      </a-button>
    </div>

    <div class="card-body">
      <!-- Activity Filter -->
      <div class="d-flex align-items-center mb-3 flex-wrap" style="gap: 8px">
        <label class="font-weight-bold mb-0 mr-2">{{ $t("accueil.activite") }}:</label>
        <a-select
          v-model="selectedActivityFilter"
          :placeholder="$t('inscription.chercherParActivite')"
          style="width: 280px;"
          allow-clear
          @change="handleActivityFilter"
        >
          <a-select-option value="">
            {{ $t('recette.tous') }}
          </a-select-option>
          <a-select-option
            v-for="activity in uniqueActivities"
            :key="activity.id"
            :value="activity.id"
          >
            {{ activity.name }}
          </a-select-option>
        </a-select>
        <template v-if="selectedActivityFilter && selectedActivityFilter !== ''">
          <label class="font-weight-bold mb-0 mr-2">{{ $t("sms.groupe") }}:</label>
          <a-select
            v-model="selectedGroupFilter"
            :placeholder="$t('inscriptionActivites.filterByGroup')"
            style="width: 200px;"
            allow-clear
            @change="handleGroupFilter"
          >
            <a-select-option value="">
              {{ $t('recette.tous') }}
            </a-select-option>
            <a-select-option value="__ungrouped__">
              {{ $t("all.nonGroupAssigned") }}
            </a-select-option>
            <a-select-option
              v-for="group in currentActivityGroups"
              :key="group.id"
              :value="group.id"
            >
              {{ group.name }}
            </a-select-option>
          </a-select>
          <a-button type="link" @click="clearActivityFilter" class="p-0">
            {{ $t("action.reinitialiser") }}
          </a-button>
        </template>
        <div class="ml-auto d-flex align-items-center" style="gap: 8px">
          <span
            v-if="!selectedActivityFilter"
            class="text-muted"
            style="font-size: 12px; max-width: 280px"
          >
            {{ $t("inscriptionActivites.selectActivityToManageGroups") }}
          </span>
          <a-button
            icon="team"
            :disabled="!selectedActivityFilter"
            @click="openManageGroupsModal"
          >
            {{ $t("inscriptionActivites.manageGroups") }}
          </a-button>
        </div>
      </div>
      <a-table
        :loading="tableLeading"
        :data-source="filteredActivityPayments"
        :columns="columns"
        :pagination="pagination"
        rowKey="_id"
        @change="handleTableChange"
      >
        <template slot="expandedRowRender" slot-scope="record">
          <div style="margin: 0">
            <div v-for="(fee, key) in record.fees" :key="key" class="d-inline">
              <a-tag :color="fee.fullyPaid ? 'green' : 'red'">
                <b v-if="fee.fullyPaid"
                  >{{ formatFeeName(fee.feeName, record.daily) }} {{ $t("paiement.paye") }}</b
                >
                <b v-else
                  >{{ formatFeeName(fee.feeName, record.daily) }}
                  {{ $t("paiement.impaye") }}</b
                >
              </a-tag>
            </div>
          </div>
        </template>
        <template slot="student" slot-scope="text, record">
          <router-link
            :to="`/eleve/${record.studentId}`"
            class="kit__utils__link"
            >{{ record.student }}</router-link
          >
        </template>
        <template slot="mode" slot-scope="text">
          <a-tag color="#3498db" v-if="text == 'M'">
            {{ $t("inscriptionActivites.monthlyPayment") }}
          </a-tag>
          <a-tag color="#27ae60" v-else>
            {{ $t("inscriptionActivites.installmentPayment") }}
          </a-tag>
        </template>
        <a-select
          slot="activityGroup"
          slot-scope="text, record"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          :placeholder="$t('all.nonGroupAssigned')"
          :value="record.groupId || ''"
          class="w-100"
          style="min-width: 140px"
          @change="(value) => changeActivityGroup(value, record)"
        >
          <a-select-option :value="''">{{
            $t("all.nonGroupAssigned")
          }}</a-select-option>
          <a-select-option
            v-for="group in groupsForRecord(record)"
            :key="group.id"
            :value="group.id"
          >
            {{ group.name }}
          </a-select-option>
        </a-select>
        <template slot="status" slot-scope="text, record">
          <a-tag :color="record.status == 'payed' ? 'green' : 'red'">
            <b v-if="record.status == 'payed'">{{ $t("profil.payes") }}</b>
            <b v-else> {{ $t("profil.nonPayes") }}</b>
          </a-tag>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="d-flex" style="gap: 8px;">
            <a-button
              type="primary"
              size="small"
              :loading="loadingSave"
              :disabled="record.once"
              @click="editActivityFees(record)"
            >
              <a-icon type="edit" />{{ $t("all.edit") }}
            </a-button>
            <a-popconfirm
              :title="$t('paiement.annulerInscri')"
              @confirm="() => onDelete(record)"
            >
              <a-button type="danger" size="small">
                <a-icon type="delete" href="javascript:;" />{{
                  $t("action.annuler")
                }}
              </a-button>
            </a-popconfirm>
          </div>
        </template>
        <div
          slot="filterDropdown"
          slot-scope="{
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            column,
          }"
          style="padding: 8px"
        >
          <a-input
            v-ant-ref="(c) => (searchInput = c)"
            :placeholder="`${$t('personnel.chercher')} ${column.title}`"
            :value="selectedKeys[0]"
            style="width: 188px; margin-bottom: 8px; display: block"
            @change="
              (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
            "
            @pressEnter="
              () => handleSearch(selectedKeys, confirm, column.dataIndex)
            "
          />
          <a-button
            type="primary"
            icon="search"
            size="small"
            style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
            >{{ $t("paiement.chercher") }}</a-button
          >
          <a-button
            size="small"
            style="width: 90px"
            @click="() => handleReset(clearFilters)"
            >{{ $t("action.reinitialiser") }}</a-button
          >
        </div>
        <a-icon
          slot="filterIcon"
          slot-scope="filtered"
          type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }"
        />
        <template slot="customRender" slot-scope="text, record, index, column">
          <span v-if="searchText && searchedColumn === column.dataIndex">
            <template
              v-for="(fragment, i) in text
                .toString()
                .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
            >
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
                >{{ fragment }}</mark
              >
              <template v-else>{{ fragment }}</template>
            </template>
          </span>
          <template v-else>{{ text }}</template>
        </template>
      </a-table>
    </div>

    <!-- Edit Activity Fees Modal -->
    <edit-activity-fees-modal
      :visible="editModalVisible"
      :activity-data="selectedActivity"
      @close="closeEditModal"
      @updatePayment="handleUpdatePayment"
    />

    <!-- Manage activity groups (frontend stub — no API yet) -->
    <a-modal
      :title="
        $t('inscriptionActivites.manageGroupsTitle', {
          activity: selectedActivityName || '',
        })
      "
      :visible="manageGroupsModalVisible"
      :footer="null"
      @cancel="closeManageGroupsModal"
    >
      <div class="d-flex mb-3" style="gap: 8px">
        <a-input
          v-model="newGroupName"
          :placeholder="$t('inscriptionActivites.groupName')"
          @pressEnter="addActivityGroup"
        />
        <a-button type="primary" icon="plus" @click="addActivityGroup">
          {{ $t("inscriptionActivites.addGroup") }}
        </a-button>
      </div>
      <a-empty
        v-if="!currentActivityGroups.length"
        :description="$t('inscriptionActivites.noGroupsYet')"
      />
      <a-list v-else :data-source="currentActivityGroups" bordered size="small">
        <a-list-item slot="renderItem" slot-scope="group">
          <span v-if="editingGroupId !== group.id">{{ group.name }}</span>
          <a-input
            v-else
            v-model="editingGroupName"
            size="small"
            style="max-width: 220px"
            @pressEnter="saveRenameGroup(group)"
          />
          <span slot="actions" class="d-flex align-items-center" style="gap: 4px">
            <template v-if="editingGroupId !== group.id">
              <a-button
                type="link"
                size="small"
                icon="edit"
                :title="$t('inscriptionActivites.renameGroup')"
                @click="startRenameGroup(group)"
              />
              <a-popconfirm
                :title="$t('inscriptionActivites.confirmDeleteGroup')"
                @confirm="() => deleteActivityGroup(group)"
              >
                <a-button
                  type="link"
                  size="small"
                  icon="delete"
                  class="text-danger"
                  :title="$t('inscriptionActivites.deleteGroup')"
                />
              </a-popconfirm>
            </template>
            <template v-else>
              <a-button
                type="link"
                size="small"
                icon="check"
                :title="$t('action.enregistrer')"
                @click="saveRenameGroup(group)"
              />
              <a-button
                type="link"
                size="small"
                icon="close"
                :title="$t('action.annuler')"
                @click="cancelRenameGroup"
              />
            </template>
          </span>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import { mapState } from "vuex";
import moment from "moment";
import activityMultiInsForm from "./activityMultiInsForm";
import activityMultipleRegistrationForm from "./activityMultipleRegistrationForm.vue";
import downloadByActivity from "./downloadByActivity.vue";
import { formatFeeName as formatFeeNameUtil } from "@/utilities/settings";
import EditActivityFeesModal from "@/components/comptabilite/EditActivityFeesModal.vue";
import { showApiError } from "@/utilities/showApiError";

const frMonths = {
  1: "Janvier ",
  2: "Février ",
  3: "Mars ",
  4: "Avril ",
  5: "Mai ",
  6: "Juin ",
  7: "Juillet ",
  8: "Août ",
  9: "Septembre ",
  10: "Octobre ",
  11: "November ",
  12: "Décembre ",
};
const getStatus = (fees) => {
  if (fees.find((f) => !f.fullyPaid)) return "impayed";
  else {
    return "payed";
  }
};
export default {
  computed: {
    ...mapState(["settings", "user"]),
    columns() {
      return [
        {
          title: this.$t("bulletin.nom"),
          dataIndex: "student",
          key: "student",
          scopedSlots: {
            customRender: "student",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter: (value, record) =>
            record.student
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("accueil.activite"),
          dataIndex: "name",
          key: "name",
          scopedSlots: {
            customRender: "name",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter: (value, record) =>
            record.name.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("emploi.classe"),
          dataIndex: "classroom",
          key: "classroom",
          scopedSlots: {
            customRender: "classroom",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter: (value, record) =>
            record.classroom
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("inscriptionActivites.paymentMode"),
          dataIndex: "mode",
          key: "mode",
          width: "150px",
          scopedSlots: {
            customRender: "mode",
          },
          filters: [
            { text: this.$t("inscriptionActivites.monthly"), value: "M" },
            { text: this.$t("inscriptionActivites.byInstallment"), value: "T" },
          ],

          onFilter: (value, record) => record.mode.indexOf(value) === 0,
        },
        {
          title: this.$t("sms.groupe"),
          dataIndex: "groupId",
          key: "groupId",
          width: "180px",
          scopedSlots: {
            customRender: "activityGroup",
          },
        },
        {
          title: this.$t("inscriptionActivites.globalStatus"),
          dataIndex: "status",
          key: "status",
          scopedSlots: {
            customRender: "status",
          },
          filters: [
            { text: this.$t("inscriptionActivites.paid"), value: "payed" },
            { text: this.$t("inscriptionActivites.unpaid"), value: "impayed" },
          ],
          onFilter: (value, record) => record.status.indexOf(value) === 0,
        },

        {
          title: this.$t("action.actions"),
          dataIndex: "supprimer",
          scopedSlots: { customRender: "operation" },
          //fixed: "right",
        },
      ];
    },
    uniqueActivities() {
      const map = {};
      this.actvitiyPayments.forEach((payment) => {
        const id = payment.activityId ? String(payment.activityId) : "";
        if (!id || map[id]) return;
        map[id] = { id, name: payment.name };
      });
      return Object.values(map).sort((a, b) =>
        String(a.name).localeCompare(String(b.name))
      );
    },
    selectedActivityName() {
      const found = this.uniqueActivities.find(
        (a) => a.id === this.selectedActivityFilter
      );
      return found ? found.name : "";
    },
    filteredActivityPayments() {
      let list = this.actvitiyPayments;
      if (this.selectedActivityFilter && this.selectedActivityFilter !== "") {
        list = list.filter(
          (payment) => String(payment.activityId) === this.selectedActivityFilter
        );
      }
      if (
        this.selectedActivityFilter &&
        this.selectedGroupFilter &&
        this.selectedGroupFilter !== ""
      ) {
        if (this.selectedGroupFilter === "__ungrouped__") {
          list = list.filter((payment) => !payment.groupId);
        } else {
          list = list.filter(
            (payment) => payment.groupId === this.selectedGroupFilter
          );
        }
      }
      return list;
    },
    currentActivityGroups() {
      if (!this.selectedActivityFilter) return [];
      return this.activityGroupsByActivityId[this.selectedActivityFilter] || [];
    },
  },
  components: {
    activityMultiInsForm,
    activityMultipleRegistrationForm,
    downloadByActivity,
    EditActivityFeesModal,
  },
  async created() {
    this.tableLeading = true;
    this.form = this.$form.createForm(this, { name: "addActivityForm" });

    const classPromise = apiClient
      .post("/classrooms/filter", {
        query: {
          status: "active",
        },
        aggregation: {
          $project: {
            _id: 1,
            name: 1,
          },
        },
      })
      .then((res) => (this.classList = res.data))
      .catch((e) =>
        this.$message.error(this.$t("inscriptionActivites.noClassFound"))
      );
    const paymentPromise = this.getActivitiesPayments();

    await Promise.all([classPromise, paymentPromise]);
  },
  data() {
    return {
      frMonths,
      loadingClasse: false,
      classList: [],
      actvitiyPayments: [],
      loading: false,
      tableLeading: true,
      searchInput: null,
      inscriptinActDrawer: false,
      multipleRegistrationDrawer: false,
      downloadModalVisible: false,
      selectedActivityFilter: "",
      selectedGroupFilter: "",
      editModalVisible: false,
      selectedActivity: null,
      loadingSave: false,
      manageGroupsModalVisible: false,
      activityGroupsByActivityId: {},
      groupsLoading: false,
      groupActionLoading: false,
      newGroupName: "",
      editingGroupId: null,
      editingGroupName: "",
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) =>
          this.$t("all.pagination.showTotal", {
            start: range[0],
            end: range[1],
            total: total
          }),
        pageSizeOptions: ["10", "20", "50", "100"],
        size: "default",
        position: "bottom",
        style: { marginTop: "16px" },
      },
    };
  },
  methods: {
    formatFeeName(key, daily = false) {
      return formatFeeNameUtil(key, daily, this.$t.bind(this));
    },
    normalizeGroups(groups = []) {
      return groups.map((g) => ({
        id: String(g._id || g.id),
        name: g.name,
      }));
    },
    groupsForRecord(record) {
      const activityId = record.activityId ? String(record.activityId) : "";
      if (!activityId) return [];
      return this.activityGroupsByActivityId[activityId] || [];
    },
    async loadActivityGroups(activityId) {
      if (!activityId) return [];
      this.groupsLoading = true;
      try {
        const res = await apiClient.get(
          `/activityGroup/byActivity/${activityId}`
        );
        const groups = this.normalizeGroups(res.data.groups || []);
        this.$set(this.activityGroupsByActivityId, String(activityId), groups);
        return groups;
      } catch (err) {
        showApiError(this, err);
        return [];
      } finally {
        this.groupsLoading = false;
      }
    },
    async prefetchGroupsForPayments() {
      const ids = [
        ...new Set(
          this.actvitiyPayments
            .map((p) => (p.activityId ? String(p.activityId) : ""))
            .filter(Boolean)
        ),
      ];
      await Promise.all(ids.map((id) => this.loadActivityGroups(id)));
    },
    openManageGroupsModal() {
      if (!this.selectedActivityFilter) {
        this.$message.warning(this.$t("inscriptionActivites.selectActivityFirst"));
        return;
      }
      this.manageGroupsModalVisible = true;
      this.loadActivityGroups(this.selectedActivityFilter);
    },
    closeManageGroupsModal() {
      this.manageGroupsModalVisible = false;
      this.newGroupName = "";
      this.cancelRenameGroup();
    },
    async addActivityGroup() {
      const name = (this.newGroupName || "").trim();
      if (!name || !this.selectedActivityFilter || this.groupActionLoading) return;
      this.groupActionLoading = true;
      try {
        const res = await apiClient.post("/activityGroup", {
          activity: this.selectedActivityFilter,
          name,
        });
        const group = { id: String(res.data._id), name: res.data.name };
        const list = [
          ...(this.activityGroupsByActivityId[this.selectedActivityFilter] || []),
          group,
        ];
        this.$set(
          this.activityGroupsByActivityId,
          this.selectedActivityFilter,
          list
        );
        this.newGroupName = "";
        this.$message.success(this.$t("inscriptionActivites.groupCreated"));
      } catch (err) {
        showApiError(this, err);
      } finally {
        this.groupActionLoading = false;
      }
    },
    startRenameGroup(group) {
      this.editingGroupId = group.id;
      this.editingGroupName = group.name;
    },
    cancelRenameGroup() {
      this.editingGroupId = null;
      this.editingGroupName = "";
    },
    async saveRenameGroup(group) {
      const name = (this.editingGroupName || "").trim();
      if (!name || !this.selectedActivityFilter || this.groupActionLoading) return;
      this.groupActionLoading = true;
      try {
        await apiClient.patch(`/activityGroup/${group.id}`, { name });
        const list = (
          this.activityGroupsByActivityId[this.selectedActivityFilter] || []
        ).map((g) => (g.id === group.id ? { ...g, name } : g));
        this.$set(
          this.activityGroupsByActivityId,
          this.selectedActivityFilter,
          list
        );
        this.actvitiyPayments.forEach((p) => {
          if (p.groupId === group.id) {
            this.$set(p, "groupName", name);
          }
        });
        this.cancelRenameGroup();
        this.$message.success(this.$t("inscriptionActivites.groupRenamed"));
      } catch (err) {
        showApiError(this, err);
      } finally {
        this.groupActionLoading = false;
      }
    },
    async deleteActivityGroup(group) {
      if (!this.selectedActivityFilter || this.groupActionLoading) return;
      this.groupActionLoading = true;
      try {
        await apiClient.delete(`/activityGroup/${group.id}`);
        const list = (
          this.activityGroupsByActivityId[this.selectedActivityFilter] || []
        ).filter((g) => g.id !== group.id);
        this.$set(
          this.activityGroupsByActivityId,
          this.selectedActivityFilter,
          list
        );
        this.actvitiyPayments.forEach((p) => {
          if (
            String(p.activityId) === this.selectedActivityFilter &&
            p.groupId === group.id
          ) {
            this.$set(p, "groupId", "");
            this.$set(p, "groupName", "");
          }
        });
        if (this.selectedGroupFilter === group.id) {
          this.selectedGroupFilter = "";
        }
        this.pagination.total = this.filteredActivityPayments.length;
        this.$message.success(this.$t("inscriptionActivites.groupDeleted"));
      } catch (err) {
        showApiError(this, err);
      } finally {
        this.groupActionLoading = false;
      }
    },
    async changeActivityGroup(groupId, record) {
      const groups = this.groupsForRecord(record);
      const group = groups.find((g) => g.id === groupId);
      const previous = {
        groupId: record.groupId || "",
        groupName: record.groupName || "",
      };
      this.$set(record, "groupId", groupId || "");
      this.$set(record, "groupName", group ? group.name : "");
      try {
        if (!groupId) {
          await apiClient.patch("/activityGroup/unassign", {
            paymentId: record._id,
          });
          this.$message.success(this.$t("inscriptionActivites.groupUnassigned"));
        } else {
          await apiClient.put("/activityGroup/assign", {
            paymentId: record._id,
            activityGroup: groupId,
          });
          this.$message.success(this.$t("inscriptionActivites.groupAssigned"));
        }
        this.pagination.total = this.filteredActivityPayments.length;
      } catch (err) {
        this.$set(record, "groupId", previous.groupId);
        this.$set(record, "groupName", previous.groupName);
        showApiError(this, err);
      }
    },
    startInsDrawer() {
      this.inscriptinActDrawer = true;
    },
    onClose() {
      this.inscriptinActDrawer = false;
      if (this.$refs.activityMultiInsForm) {
        this.$refs.activityMultiInsForm.resetForm();
      }
    },
    startMultipleRegistrationDrawer() {
      this.multipleRegistrationDrawer = true;
    },
    onMultipleRegistrationClose() {
      this.multipleRegistrationDrawer = false;
      if (this.$refs.multipleRegistrationForm) {
        this.$refs.multipleRegistrationForm.resetAll();
      }
    },
    updateActivitiesMultipleRegistration() {
      this.multipleRegistrationDrawer = false;
      if (this.$refs.multipleRegistrationForm) {
        this.$refs.multipleRegistrationForm.resetAll();
      }
      this.getActivitiesPayments();
    },
    moment,
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onDelete(key) {
      const { _id } = key;
      apiClient
        .patch("/payment/" + _id, {
          data: {
            status: "inactive",
          },
        })
        .then((r) => {
          this.$message.success(this.$t("success.inscriSupp"));
          const dataSource = [...this.actvitiyPayments];
          this.actvitiyPayments = dataSource.filter((item) => item._id !== _id);
        })
        .catch((r) => {
          this.$message.error(this.$t("error.impoInscriSupp"));
        });
    },
    updateActivities() {
      this.inscriptinActDrawer = false;
      this.getActivitiesPayments();
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
    },
    async handleActivityFilter(value) {
      this.selectedActivityFilter = value || "";
      this.selectedGroupFilter = "";
      this.pagination.current = 1;
      if (this.selectedActivityFilter) {
        await this.loadActivityGroups(this.selectedActivityFilter);
      }
      this.pagination.total = this.filteredActivityPayments.length;
    },
    handleGroupFilter(value) {
      this.selectedGroupFilter = value || "";
      this.pagination.current = 1;
      this.pagination.total = this.filteredActivityPayments.length;
    },
    clearActivityFilter() {
      this.selectedActivityFilter = "";
      this.selectedGroupFilter = "";
      this.pagination.current = 1;
      this.pagination.total = this.actvitiyPayments.length;
    },
    async getActivitiesPayments() {
      this.tableLeading = true;
      return apiClient
        .get("/payment/etatImpaye/activity/all")
        .then(async (res) => {
          this.actvitiyPayments = res.data.map((p) => ({
            ...p,
            classroom:
              this.classList.find((c) => c._id == p.classroom)?.name ?? "--",
            status: getStatus(p.fees),
            activityId: p.activityId ? String(p.activityId) : "",
            groupId: p.groupId ? String(p.groupId) : "",
            groupName: p.groupName || "",
          }));
          this.pagination.total = this.filteredActivityPayments.length;
          await this.prefetchGroupsForPayments();
        })
        .catch((e) => {
          console.log(e);
          this.$message.error(this.$t("error.aucInscri"));
        })
        .finally(() => {
          this.tableLeading = false;
        });
    },
    editActivityFees(record) {
      const transformedRecord = {
        ...record,
        tranches: record.tranchesFee || [],
        fees: record.fees.map(fee => ({
          feeName: fee.feeName,
          feeLabel: fee.feeLabel,
          repReductionValue: fee.repReductionValue,
          feeBeforeRed: fee.feeBeforeRed,
          feeAfterReduction: fee.feeAfterReduction,
          isPayed: {
            fullyPaid: fee.fullyPaid,
            paid: fee.paid,
            remaining: fee.remaining
          }
        }))
      };

      this.selectedActivity = transformedRecord;
      this.editModalVisible = true;
    },
    closeEditModal() {
      this.editModalVisible = false;
      this.selectedActivity = null;
    },
    async handleUpdatePayment() {
      this.loadingSave = true;
      try {
        await this.getActivitiesPayments();
      } catch (error) {
        this.$message.error(this.$t('error.modif'));
        console.error('Error updating payments:', error);
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>
